<app-header />

<mat-drawer-container class="export-layout">
  <mat-drawer
    class="export-drawer"
    mode="over"
    position="end"
    [opened]="isDrawerOpen"
    (backdropClick)="closeExport()"
    (openedChange)="onDrawerOpenChange($event)"
  >
    @if (selectedExport) {
      <div class="drawer-header between">
        <h3>Export details</h3>
        <button mat-button (click)="closeExport()">Close</button>
      </div>

      <p>
        Mode: <b>{{ formatExportMode(selectedExport) }}</b>
        <br />
        Status: <b>{{ getDisplayStatus(selectedExport.status) }}</b>
        <br />
        Created at: <b>{{ selectedExport.createdAt | date: 'medium' }}</b>
        <br />
        Finished at: <b>{{ selectedExport.finishedAt | date: 'medium' }}</b>
        @if (selectedExport.key && isExportFinished(selectedExport)) {
          <br />
          Download link:
          @if (!selectedExport.isDownloading) {
            <span class="download" (click)="download(selectedExport)">{{ selectedExport.key }}</span>
          } @else {
            <span>Preparing download... Please wait, this may take a few minutes for large files.</span>
          }
        } @else if (selectedExport.key) {
          <br />
          Download link: <span>Preparing download... Please wait, this may take a few minutes for large files.</span>
        }
      </p>

      <h4>Filters</h4>
      <export-nested-object [obj]="cleanFilterObject(selectedExport.filter)" />
    }
  </mat-drawer>

  <mat-drawer-content>
    <mat-card style="margin: 0 var(--global-padding)">
      <mat-card-header>
        <mat-card-title> Exports </mat-card-title>
        <span class="spacer"></span>
        <button
          mat-button
          color="primary"
          (click)="downloadTaxons()"
          class="download-taxons-button"
          [checkPermission]="['export', 'download']"
        >
          Download taxa list
        </button>
        <button
          mat-stroked-button
          color="primary"
          (click)="triggerRefresh()"
          [checkPermission]="['export', 'list']"
          class="refresh-button"
        >
          Refresh
        </button>
        <button mat-flat-button routerLink="create" [checkPermission]="['export', 'export']">
          New export
        </button>
      </mat-card-header>
      <mat-card-content>
        <p [checkPermission]="['export', 'list']" class="no-permission-warning">
          You do not have permission to export.
        </p>
        <app-export-table
          tableAlias="export"
          [checkPermission]="['export', 'list']"
          (rowSelected)="openExport($event)"
        />
      </mat-card-content>
    </mat-card>
  </mat-drawer-content>
</mat-drawer-container>
